import './style.scss';

function iconboxRenderer($block) {
    document.addEventListener('aos:in:increment', ({ detail }) => {
        console.log('animated in', detail);
        jQuery(detail).find('.keyfigure__text__number__span').css('--num', detail.dataset.to);
    });

    document.addEventListener('aos:out:increment', ({ detail }) => {
        console.log('animated out', detail);
        jQuery(detail).find('.keyfigure__text__number__span').css('--num', detail.dataset.from);
    });

    window.setInterval(function() {
        $('[data-aos="increment"]').each(function(i,e) {
            if ( $(e).hasClass('aos-animate') ) {
                $(e).find('.keyfigure__text__number__span').css('--num', $(e).data('to'));
            }
        });
    }, 100);
}

// Initialize dynamic block preview (editor).
if( window.acf ) {
	window.acf.addAction( 'render_block_preview/type=icon-box', iconboxRenderer );
}